import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IOrganisation } from 'src/app/interfaces/organisation';
import { CategoryApiService } from 'src/modules/category/services/category-api-service';
import { CategoryDataSource } from 'src/modules/category/services/category-data-source';
@Component({
    selector: 'user-manage',
    templateUrl: 'component.html',
    styleUrls: ['component.scss'],
    standalone: false
})
export class CreateOrgansation implements OnInit, OnDestroy {
  constructor(
    private fb: FormBuilder,
    private CategoryApi: CategoryApiService,
    protected dialogRef: MatDialogRef<CreateOrgansation>,
    @Inject(MAT_DIALOG_DATA) public config
  ) {}
  public categories;
  public form: FormGroup;
  ngOnInit() {
    this.form = this.fb.group({
      title: [null],
      menu_title: [null],
      category_id: [null],
      product_id: [null]
    });

    this.getCategories();
  }

  async getCategories() {
    const categories = await this.CategoryApi.getAllCategories(
      'organisation-admin'
    );
    this.categories = categories['data'];
  }

  onSubmit() {
    const org = this.form.getRawValue() || null;

    this.config.DataSource.save(org).then((result) => {
      this.dialogRef.close(result);
    });
  }
  ngOnDestroy() {}
}
